import React, { FC, InputHTMLAttributes } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import cn from 'classnames';

import styles from './styles.module.scss';
import { ReactComponent as Binance } from '../../assets/images/logo/binance.svg';

type Props = {
  className?: string,
  error?: string | boolean,
  customOptions?: { [key: string]: any },
};

const DEFAULT_MASK_OPTIONS = {
  suffix: '',
  prefix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '',
  allowDecimal: true,
  decimalLimit: 40,
  integerLimit: 40,
  allowNegative: false,
  allowLeadingZeroes: false,
  requireDecimal: false,
};

export const InputAmountInfo: FC<Props & InputHTMLAttributes<HTMLInputElement>> = ({
  className,
  placeholder = '',
  onChange,
  value,
  onBlur,
  name,
  disabled,
  error,
  customOptions,
}) => {
  const currencyMask = React.useCallback(createNumberMask({
    inputMode: 'numeric',
    ...DEFAULT_MASK_OPTIONS,
    ...customOptions,
  }), []);

  return (
    <div className={cn(styles.inputWrapper, className)}>
      <MaskedInput
        mask={currencyMask}
        disabled={disabled}
        onBlur={onBlur}
        name={name}
        value={value}
        onChange={onChange}
        className={cn(styles.input, { [styles.error]: !!error })}
        placeholder={placeholder}
      />
      <Binance className={styles.priceIcon} />
    </div>
  );
};
